import { useFieldArray, useForm } from 'react-hook-form';
import React from 'react';
import FormInputText from '@app/component/form/input/text/FormInputText';
import FormButton from '@app/component/form/button/FormButton';
import _isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';
import get from 'lodash/get';

const AlertAddExtraEmailsField: React.FunctionComponent<{ form: any }> = ({ form }) => {

	const { fields, append, remove } = useFieldArray({
		control: form.control, // control props comes from useForm (optional: if you are using FormContext)
		name: 'extraEmails', // unique name for your Field Array
	});

	const extraEmailsWatch: string[] = form.watch('extraEmails');

	const emailLocalForm = useForm();

	const onAddEmail = (data: any) => {
		if (!extraEmailsWatch.includes(data.email)) {
			form.setValue('extraEmails', [...extraEmailsWatch, data.email]);
			form.clearErrors('extraEmails');
			emailLocalForm.setValue('email', '');
		}
	};

	const onRemoveEmail = (index: number) => {
		const emails = [...extraEmailsWatch.slice(0, index), ...extraEmailsWatch.slice(index + 1)];
		form.setValue('extraEmails', _isEmpty(emails) ? [] : [...emails]);
	};

	return <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
		<div>
			<h2 className="text-base font-semibold leading-7 text-gray-900">Push Notifications Emails</h2>
			<p className="mt-1 text-sm leading-6 text-gray-600">
				Add Extra emails to receive the alert
			</p>
		</div>

		<div>

			<div className="flex justify-between">
				<label className="label">Additional Email</label>
			</div>
			<div className="sm:flex space-x-4 mt-0.5">
				<div className="flex-grow">
					<FormInputText validation="email" form={emailLocalForm} name="email" placeholder="Insert email" />
				</div>
				<div>
					<FormButton state="white" extraClassName="text-blue-600"
											onClick={emailLocalForm.handleSubmit(onAddEmail)}>Add</FormButton>
				</div>
			</div>
			<div className="sm:flex space-x-4 mt-0.5">
				{has(form.formState.errors, 'extraEmails') && <p className="text-xs text-red-500">{get(form.formState.errors, 'extraEmails.message')}</p>}
			</div>
		</div>
		<div className="mt-2">
			<ul role="list" className="divide-y divide-gray-200">
				{!!extraEmailsWatch && extraEmailsWatch.reverse().map((email, index) => <li key={index}
																																					className="flex justify-between gap-x-6 py-4">
					<div className="flex flex-col">
						<span className="text-sm font-medium text-gray-700">{email}</span>
					</div>
					<button type="button" onClick={() => onRemoveEmail(index)}
									className="font-semibold text-xs text-blue-600 hover:text-blue-500">
						Remove
					</button>
				</li>)}
			</ul>
		</div>
	</div>;

};

export default AlertAddExtraEmailsField;